import React, { Component } from 'react'
// import Chart from 'chart.js';
import Chart from 'chart.js/auto';

let myDonutChart

export default class NewDonutChart extends Component {
    chartRef = React.createRef()

    componentDidMount() {
        this.buildChart()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.buildChart()
        }
    }

    buildChart = () => {
        const myChartRef = this.chartRef.current.getContext("2d")

        if (typeof myDonutChart !== "undefined") myDonutChart.destroy();

        myDonutChart = new Chart(myChartRef, {
            type: 'doughnut',
            data: this.props.data
        })
    }

    render() {
        return (
            <div className={'donutChartContainer'}>
                <canvas id='myChart' height={this.props.height} width={this.props.width} ref={this.chartRef}/>
            </div>
        )
    }
}
